import React, { useEffect, useState } from 'react'
import { animated, useSpring } from 'react-spring'
import { useMeasure } from 'react-use'

export const AccordionItem = ({
  label,
  isCollapsed,
  handleClick,
  children,
}) => {
  const defaultHeight = '0px'

  // The height of the content inside of the accordion
  const [contentHeight, setContentHeight] = useState(defaultHeight)

  // Gets the height of the element (ref)
  const [ref, { height }] = useMeasure()

  // Animations
  const expandSpring = useSpring({
    // config: { friction: 10 },
    height: isCollapsed ? defaultHeight : `${contentHeight}px`,
  })
  const spinSpring = useSpring({
    // config: { friction: 10 },
    transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)',
  })

  useEffect(() => {
    //Sets initial height
    setContentHeight(height)

    //Adds resize event listener
    window.addEventListener('resize', setContentHeight(height))

    // Clean-up
    return window.removeEventListener('resize', setContentHeight(height))
  }, [height])

  return (
    <div className="accordion-item">
      <button className="accordion-button" onClick={handleClick}>
        <h2>{label}</h2>
        <animated.svg
          className="accordion-arrow"
          viewBox="0 0 18 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={spinSpring}
        >
          <path
            d="M1.5 8.5L9 1L16.5 8.5"
            stroke="#B9BFD2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </animated.svg>
      </button>
      <animated.div
        className={'accordion-content'}
        aria-expanded={!isCollapsed}
        style={{
          overflow: 'hidden',
          ...expandSpring,
        }}
      >
        <div ref={ref}>
          <div
            style={{
              borderTop: '1px solid var(--borderGrey)',
              margin: '0rem 1rem',
              padding: '1rem 0rem',
            }}
          >
            {children}
          </div>
        </div>
      </animated.div>
    </div>
  )
}

export const Accordion = ({ defaultIndex, onItemClick, children }) => {
  const [bindIndex, setBindIndex] = useState(defaultIndex)

  const changeItem = itemIndex => {
    if (typeof onItemClick === 'function') onItemClick(itemIndex)
    if (itemIndex === bindIndex) setBindIndex(null)
    if (itemIndex !== bindIndex) setBindIndex(itemIndex)
  }
  return (
    <>
      {children.map(({ props }) => (
        <AccordionItem
          isCollapsed={bindIndex !== props.index}
          label={props.label}
          handleClick={() => changeItem(props.index)}
          key={`accordion-item-${props.index}`}
        >
          {props.children}
        </AccordionItem>
      ))}
    </>
  )
}
